import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  Paper
} from '@mui/material';
import { _post } from '../../Config/axiosInstance'; // Replace with your correct import

function AddOfferPage() {
  
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

  const [offerName, setOfferName] = useState('');
const [offermovietickets, setOffermovietickets] = useState(0);
const [offerfooddiscount, setOfferfooddiscount] = useState(0);
const [offerother, setOfferother] = useState('');
const [offerexpiry, setOfferexpiry] = useState(1);
const [maxmovieticketsmonth, setMaxmovieticketsmonth] = useState();

  

  const handleSubmit = async () => {
    console.log(offerexpiry,offerfooddiscount,offermovietickets)
    if (!offerName || 
      !offerexpiry ||
      !offerfooddiscount ||
      !offermovietickets ||
      !maxmovieticketsmonth
      //|| isNaN(offerexpiry) ||
      // isNaN(offerfooddiscount) ||
      // isNaN(offermovietickets)
    ) {
      setAlert({ open: true, message: 'Please enter valid numbers in all fields.', severity: 'error' });
      return;
    }

    const payload = {
      offerName:offerName,
      offerexpiry: Number(offerexpiry),
      offerfooddiscount: Number(offerfooddiscount),
      offermovietickets: Number(offermovietickets),
      offerother:offerother,
      maxmovieticketsmonth: Number(maxmovieticketsmonth)
    };

    console.log(payload);

    try {
      const response = await _post('/saveoffer', payload); // Replace with your actual API

      //if(response.data.msg.code)
      setAlert({ open: true, message: 'Offer added successfully!', severity: 'success' });
      setOfferName('');
      setOffermovietickets('');
      setOfferfooddiscount('');
      setOfferother('');
      setOfferexpiry('');
      setMaxmovieticketsmonth('');
    } catch (error) {
      console.error(error);
      setAlert({ open: true, message: 'Failed to add offer.', severity: 'error' });
    }
  };

  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false });
  };

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", mt: 5 }}>
      <Paper sx={{ p: 4, boxShadow: 3 }}>
        <Typography variant="h5" gutterBottom>
          Add New Offer
        </Typography>

        <TextField
          fullWidth
          label="Offer Name"
          name="name"
          value={offerName}
          onChange={(e) => setOfferName(e.target.value)}
          margin="normal"
        />

        <TextField
          fullWidth
          label="Offer Expiry (in months)"
          // type="number"
          value={offerexpiry}
          onChange={(e) => setOfferexpiry(e.target.value)}
          margin="normal"
        />

        <TextField
          fullWidth
          label="Food Discount (%)"
          // type="text"
          value={offerfooddiscount}
          onChange={(e) => setOfferfooddiscount(e.target.value)}
          margin="normal"
        />

        <TextField
          fullWidth
          label="Max Ticket Count per Offer"
          // type="text"
          value={offermovietickets}
          onChange={(e) => setOffermovietickets(e.target.value)}
          margin="normal"
        />

        <TextField
          fullWidth
          label="Max Ticket Count per Month"
          // type="text"
          value={maxmovieticketsmonth}
          onChange={(e) => setMaxmovieticketsmonth(e.target.value)}
          margin="normal"
        />

        <TextField
          fullWidth
          label="Other Offers"
          //  type="text"
          value={offerother}
          onChange={(e) => setOfferother(e.target.value)}
          margin="normal"
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleSubmit}
        >
          Submit Offer
        </Button>
      </Paper>

      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={alert.severity}
          variant="filled"
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default AddOfferPage;
